import { encodeData, isUserLoggedIn } from '@airtel/air-utils';

import {
   isMobileApp,
   isNewIOSApp,
   getAnalyticsParams,
   makeDigitalStorePayment,
} from '@airtel-lego/native-app-bridge';

const removeBlankAttributes = (obj: Record<string, string>) => {
   const result: Record<string, string> = {};
   for (const key in obj) {
      if (obj[key]) {
         result[key] = obj[key];
      }
   }
   return result;
};

const isLocalOrTndEnv = (hostname: string) => {
   const normalizedHost = hostname.toLowerCase();
   return (
      normalizedHost.includes('localhost') ||
      normalizedHost.includes('127.0.0.1') ||
      normalizedHost.includes('tnd.airtel.com')
   );
};

const isEmbeddedInIframe = () => {
   try {
      return window.self !== window.top;
   } catch (error) {
      return true;
   }
};

export const navigateToPayment = async ({ args, onUserAction, getState }: any) => {
   const lob = 'PREPAID';
   const { storeValues } = getState();

   const msisdn = storeValues?.appData?.msisdn;
   const siNumber = storeValues?.numberContext?.selectedNumber;
   const orderType = storeValues?.appData?.orderType;
   const rtn = storeValues?.user?.loggedInNumber;
   const payableAmount = storeValues?.planInfo?.planPrice;
   const referenceOrderId = storeValues?.orderData?.cartId;
   const planName = storeValues?.planInfo?.planName ?? '';
   const orderItem = storeValues?.orderData?.cartItemId ?? '';
   const utm_campaign = storeValues?.additionalData?.queryParams?.utm_campaign || '';
   const utm_medium = storeValues?.additionalData?.queryParams?.utm_medium || '';
   const utm_layout = storeValues?.additionalData?.queryParams?.utm_layout || '';
   const address = storeValues?.pincodeContext?.pincodeDetails?.addressString || '';
   const price = storeValues?.planInfo?.planPrice|| '';
   const circleId = storeValues?.pincodeContext?.pincodeDetails?.circleId || '';
   const isApp = isMobileApp();

   let params = new URLSearchParams(window.location.search);
   let utm_source = params.get('utm_source') || '';

   let urlParams: { [name: string]: string } = {
      msisdn,
      utm_source,
      price
   };

   const urlSearchParams = new URLSearchParams(removeBlankAttributes(urlParams));

//    const queryString = Object.entries(removeBlankAttributes(urlParams))
//   .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
//   .join('&');
//   let thankYouPageUrl = `https://${window.location.hostname}/kyc/prepaid/thank-you?${queryString}`;

   const hostname = window.location.hostname;
   const isLocalOrTnd = isLocalOrTndEnv(hostname);
   const redirectHost = isLocalOrTnd ? 'www.airtel.in' : hostname;

   const cancelUrl = `https://www.airtel.in/`;
   let thankYouPageUrl = `https://${redirectHost}/kyc/prepaid/thank-you?${urlSearchParams?.toString()}`;
   let linkRedirectionUrl = '';
   let redirectionUrl = `https://${redirectHost}/pay/summary?omv=v2`;

   if(hostname.includes("tnd.airtel.com")){
      thankYouPageUrl += `&pagesEnv=KONGQA&apiType=PORTFOLIO`;
      redirectionUrl += `&apiEnv=KONG178`
   }

   const encodedUrl = encodeURIComponent(encodeURIComponent(thankYouPageUrl));

   // Create deep link URL for mobile apps
   let thankYouPageUrlDeepLink = `myairtel://webview?au=${encodeURIComponent(thankYouPageUrl)}`;
   if(isNewIOSApp()) {
      thankYouPageUrlDeepLink = `myairtel://webview?ax=${encodeURIComponent(thankYouPageUrl)}`;
   }

   const appCheckoutPayload = createAppCheckoutPayload(
      payableAmount,
      thankYouPageUrlDeepLink,
      msisdn,
      rtn,
      siNumber,
      referenceOrderId,
      orderType,
      circleId
   );

    // Create web payment payload data
    const webPaymentPayload = createPaymentPayLoadForWeb(
      lob,
      msisdn, //provisionSi
      siNumber,
      cancelUrl,
      payableAmount, //totalPaymentPrice
      thankYouPageUrl,
      referenceOrderId, // COM order Id
      msisdn, // rtn
      utm_source,
      utm_campaign,
      utm_medium,
      linkRedirectionUrl,
      orderItem,
      orderType,
      redirectionUrl,
      circleId
   );

   const paymentPayload = async () => {
      if (isApp) {
        const { appNumber } = (await getAnalyticsParams()) || {};
    
        if (isNewIOSApp()) {
         //TODO - appNumber will changes post payment changes are released in bridge
          if (appNumber > 964) {
            makeDigitalStorePayment(appCheckoutPayload);
            return ""
          } else {
            return webPaymentPayload
          }
        } else {
          if (appNumber > 5714) {
            makeDigitalStorePayment(appCheckoutPayload);
            return ""
          } else {
            return webPaymentPayload
          }
        }
      } else {
         return webPaymentPayload
      }
    };

    const payload = await paymentPayload();

  
   // Web payment flow - executes for web and in app where appNumber is below configured values
   // payload === "" means makeDigitalStorePayment was called (native payment) — nothing more to do
   if (payload === "") {
      return;
   }
   if (payload != null) {
      let url = isLocalOrTnd
         ? `https://www.airtel.in/pay/?payloadData=${payload}`
         : `https://${hostname}/pay/?payloadData=${payload}`;
      sessionStorage.setItem('paymentPayloadUrl', url);

      return onUserAction({
         actions: [
            {
               type: 'navigation',
               payload: {
                  externalUrl: url,
                  shouldAddSearchParams: false,
                  shouldOpenWindow: isEmbeddedInIframe(),
               },
            },
         ],
      });
   } else {
      return onUserAction({
         actions: [
            {
               type: 'showToast',
               payload: {
                  message: 'Something Went Wrong',
                  duration: 2000,
                  position: 'top',
                  toastType: 'error',
               },
            },
         ],
      });
   }
};

export const createPaymentPayLoadForWeb = (
   lob: string,
   provisionSi: string,
   siNumber: string,
   cancelUrl: string,
   price: string,
   thankYouPageUrl: string,
   orderId?: string,
   rtn?: string,
   utm_source?: string,
   utm_campaign?: string,
   utm_medium?: string,
   linkRedirectionUrl?: string,
   orderItem?: string,
   orderType?: string,
   redirectionUrl?: string,
   circleId?: string
) => {
   const paymentObj = {
      order: {
         lobName: lob,
         paymentAmount: price, // paymentAmount = packAmount - coupons
         benefitAmount: price, // benefitAmount = //same as payment amount
         requestorId: 'PREPAID_SKYC',
         requestType: 'SKYC',
         acquisitionType: 'skyc',
         scenarioType: orderType, // NEW or MNP
         serviceInstance: siNumber,
         circleId : Number(circleId)
      },
      lobData: {
         orderReferenceId: orderId,
      },
      billSummary: {
         paymentAmount: price,
         detailSection: [
            {
               key: 'Bill Payment',
               value: `₹${price}`,
            },
         ],
         transactionText: `Prepaid | ${siNumber}`,
      },
      callBack: {
         redirectionUrl: redirectionUrl,
         cancelUrl,
         linkRedirectionUrl,
      },
      resultSummary: [
         {
            heading: `Prepaid Recharge | ${siNumber}`,
            subHeading: 'Bill Payment',
            value: `₹${price}`,
         },
      ],
      result: {
         resultDetails: {
            redirectionUrlAfterResult: thankYouPageUrl,
            needToRedirectAfterResult: true, 
         },
         resultSummary: [
            {
               heading: 'SKYC Payment',
               value: `₹${price}`,
            },
         ],
      },
      flow: {
         isAuthFlow: isUserLoggedIn()
      },
   };

   return encodeData(paymentObj);
};

/**
 * Create quick checkout payload for new Android/iOS apps (DTH journey)
 * Used for app versions: iOS > 964, Android > 5714
 */
export const createAppCheckoutPayload = (
   price: string,
   thankYouPageUrlDeepLink: string,
   msisdn?: string,
   rtn?: string,
   siNumber?: string,
   referenceOrderId?: string,
   orderType?: string,
   circleId?: string
) => {
   const hostname = window.location.hostname
   let url = hostname.includes("tnd.airtel.com") ? "https://kongqa.airtel.com/preprod-178/order-service/v3/order" : "https://paydigi.airtel.in/order-service/v3/order"
   const paymentObj = {
      checkoutSdk : { totalAmount: price.toString(),
      number: siNumber,
      undiscountedAmount: price.toString(),
      subtitle: ['Prepaid skyc bill', siNumber],
      paymentLob: 'PREPAID',
      siNumber: siNumber,
      requestorName: 'SAFO',
      requesterid: 'PREPAID_SKYC',
      order: {
         request: {
            rtn: rtn,
            items: [
               {
                  orderDetailReq: {
                     lob: 'PREPAID',
                     siNumber: siNumber,
                     orderReferenceId: referenceOrderId,
                     requestType: 'SKYC',
                     scenarioType: orderType, // NEW or MNP
                     acquisitionType: 'skyc',
                     apiKeyMap: {
                        billAmount: price.toString(),
                     },
                     biller: '',
                     directPay: true,
                     packId: price.toString(),
                     circleId : Number(circleId)
                  },
               },
            ],
            journeyType: 'SKYC',
         },
         config: {
            redirectionURLOnPayment: thankYouPageUrlDeepLink,
            redirectAfterPolling: true,
            redirectionPostPayment: true,
         },
         url,
      },
   }
   };
   return JSON.stringify(paymentObj);
};

export const navigateToPaymentRevamp = async ({ args, onUserAction, getState }: any) => {

   const { storeValues } = getState();

   const lob = storeValues?.appData?.lob;
   const msisdn = storeValues?.appData?.msisdn;
   const orderType = storeValues?.appData?.connectionType;
   const siNumber = orderType.toLowerCase() == 'mnp' ? storeValues?.appData?.portingNumber : storeValues?.appData?.newMsisdn
   const rtn = storeValues?.user?.loggedInNumber;
   const payableAmount = lob.toLowerCase() == 'prepaid' ? storeValues?.appData?.planData?.planPrice : storeValues?.appData?.planData?.activationCharge
   const referenceOrderId = storeValues?.appData?.cartData?.cartId;
   const orderItem = storeValues?.appData?.cartData?.cartItemId ?? '';
   const utm_campaign = storeValues?.additionalData?.queryParams?.utm_campaign || '';
   const utm_medium = storeValues?.additionalData?.queryParams?.utm_medium || '';
   const circleId = storeValues?.appData?.address?.circleId || '';
   const isApp = isMobileApp();

   let params = new URLSearchParams(window.location.search);
   let utm_source = params.get('utm_source') || '';

   let urlParams: { [name: string]: string } = {
      msisdn,
      utm_source,
      payableAmount
   };

   const urlSearchParams = new URLSearchParams(removeBlankAttributes(urlParams));



   const hostname = window.location.hostname;
   const isLocalOrTnd = isLocalOrTndEnv(hostname);
   const redirectHost = isLocalOrTnd ? 'www.airtel.in' : hostname;

   const cancelUrl = `https://www.airtel.in/`;
   let thankYouPageUrl = `https://${redirectHost}/kyc/verify?${urlSearchParams?.toString()}`;
   let linkRedirectionUrl = '';
   let redirectionUrl = `https://${redirectHost}/pay/summary?omv=v2`;


   // Create deep link URL for mobile apps
   let thankYouPageUrlDeepLink = `myairtel://webview?au=${encodeURIComponent(thankYouPageUrl)}`;
   if (isNewIOSApp()) {
      thankYouPageUrlDeepLink = `myairtel://webview?ax=${encodeURIComponent(thankYouPageUrl)}`;
   }

   const appCheckoutPayload = createAppCheckoutPayload(
      payableAmount,
      thankYouPageUrlDeepLink,
      msisdn,
      rtn,
      siNumber,
      referenceOrderId,
      orderType,
      circleId
   );

   // Create web payment payload data
   const webPaymentPayload = createPaymentPayLoadForWeb(
      lob,
      msisdn, //provisionSi
      siNumber,
      cancelUrl,
      payableAmount, //totalPaymentPrice
      thankYouPageUrl,
      referenceOrderId, // COM order Id
      msisdn, // rtn
      utm_source,
      utm_campaign,
      utm_medium,
      linkRedirectionUrl,
      orderItem,
      orderType,
      redirectionUrl,
      circleId
   );

   const paymentPayload = async () => {
      if (isApp) {
         const { appNumber } = (await getAnalyticsParams()) || {};

         if (isNewIOSApp()) {
            //TODO - appNumber will changes post payment changes are released in bridge
            if (appNumber > 964) {
               makeDigitalStorePayment(appCheckoutPayload);
               return ""
            } else {
               return webPaymentPayload
            }
         } else {
            if (appNumber > 5714) {
               makeDigitalStorePayment(appCheckoutPayload);
               return ""
            } else {
               return webPaymentPayload
            }
         }
      } else {
         return webPaymentPayload
      }
   };

   const payload = await paymentPayload();


   // Web payment flow - executes for web and in app where appNumber is below configured values
   // payload === "" means makeDigitalStorePayment was called (native payment) — nothing more to do
   if (payload === "") {
      return;
   }

     let url = `https://www.airtel.in/pay/?payloadData=${payload}`


   if (!hostname.includes("airtel.in")) {
      url += `&apiEnv=KONG178`
        redirectionUrl += `&apiEnv=KONG178`  
   }

   console.log("paymentPayload",paymentPayload)
   if (payload != null) {
    
      // sessionStorage.setItem('paymentPayloadUrl', url);

      return onUserAction({
         actions: [
            {
               type: 'navigation',
               payload: {
                  externalUrl: url,
                  shouldAddSearchParams: false,
                  shouldOpenWindow: isEmbeddedInIframe(),
               },
            },
         ],
      });
   }
};




//postpaid methods for payment

// export const navigateToPostpaidPaymentQC = async (onUserAction: any, localData: any, getState: any) => {
//   const lob = 'CART_ECOM';
//   const { storeValues } = getState();

//   const msisdn = storeValues?.appData?.msisdn;

//   const payableAmountStore = storeValues?.paymentContext?.paymentAmount;
//   let payableAmount = payableAmountStore !== undefined && payableAmountStore !== null ? String(payableAmountStore) : '';

//   let serviceId = storeValues?.paymentContext?.PaymentType;
//   const referenceOrderId = storeValues?.cartContext?.cartId;
//   const orderItemId = storeValues?.cartContext?.cartItemId;
//   const subLob = storeValues?.appData?.subLob || '';
//   const extraData1 = storeValues?.analyticsContext?.ed1 || '';

//   const search = window.location.search;
//   const params = new URLSearchParams(search);

//   const utm_layout = params.get('utm_layout') || 'common_bundling_otp_shift';
//   const utm_source = params.get('utm_source') || '';
//   const utm_campaign = params.get('utm_campaign') || '';
//   const utm_medium = params.get('utm_medium') || '';

//   const cancelUrlObj = new URL(window.location.href);
//   const BASE_HREF = getBaseHref();
//   const pathName = window?.location?.pathname || '';
//   const landingLayoutOverride = window?.sessionStorage?.getItem('ps_landingLayoutName');

//   const smsRedirectionLOB = 'sms_sent';
//   const name = storeValues?.cartContext?.name || '';

//   let journey = params.get('journey') || '';

//   // cartContext.address might be a string or an object with street1/city
//   const rawAddress = storeValues?.cartContext?.address || '';
//   const address =
//     typeof rawAddress === 'string'
//       ? rawAddress
//       : rawAddress?.street1 || rawAddress?.line1 || '';
//   const city =
//     typeof rawAddress === 'string'
//       ? ''
//       : rawAddress?.city || '';

//   const isApp = isMobileApp();
//   const QcSubtitle = storeValues?.cartContext?.qcSubtitle || 'Postpaid';
//   const planPrice = storeValues?.cartContext?.planPrice || '';
//   const benefit1 = storeValues?.cartContext?.benefit1 || '';
//   const benefit2Heading = storeValues?.cartContext?.benefit2Heading || '';
//   const benefit2SubHeading = storeValues?.cartContext?.benefit2SubHeading || '';

//   const transactionText =
//     'Postpaid advance amount' + (msisdn ? ` | ${msisdn}` : '');

//   let tempPrimaryHeading = planPrice ? `₹${planPrice} Plan` : '';
//   if (benefit1) tempPrimaryHeading += ` - ${benefit1}`;
//   if (benefit2Heading && benefit2SubHeading) {
//     tempPrimaryHeading += ` · ${benefit2Heading} ${benefit2SubHeading}`;
//   }
//   const primaryHeading = tempPrimaryHeading || '';
//   const subHeading = address ? `Billing address - ${address}` : '';

//   const urlParams: { [name: string]: any } = {
//     mobileNumber: msisdn,
//     journey,
//     orderItemId,
//     payableAmount,
//     orderId: referenceOrderId,
//     utm_layout,
//     utm_source,
//     utm_campaign,
//     utm_medium,
//     appointmentSubLob: subLob,
//   };

//   const linkRedirectionUrlParams: { [name: string]: any } = {
//     lob: smsRedirectionLOB,
//     orderId: referenceOrderId,
//     mobileNumber: msisdn,
//     orderItemId,
//     utm_source,
//     utm_layout,
//     utm_campaign,
//     utm_medium,
//   };

//   const urlSearchParams = new URLSearchParams(removeBlankAttributes(urlParams));
//   const linkRedirectionUrlParamsSearchParams = new URLSearchParams(
//     removeBlankAttributes(linkRedirectionUrlParams)
//   );

//   const cancelUrl = cancelUrlObj.href;

//   // Thank-you / loader URLs (aligned with existing postpaid payment util)
//   let thankYouPageUrl = `https://${window.location.hostname}${BASE_HREF}/thank-you?mobileNumber=${msisdn || ''}&journey=${journey ||
//     ''}&orderItemId=${orderItemId || ''}&landingLayoutOverride=${landingLayoutOverride || ''}`;

//   if (pathName.includes('parent-order-summary-new')) {
//     journey = 'P2P';
//     thankYouPageUrl = `https://${window.location.hostname}${BASE_HREF}/p2p-payment-loader?mobileNumber=${msisdn ||
//       ''}&journey=${journey}&orderItemId=${orderItemId ||
//       ''}&landingLayoutOverride=${landingLayoutOverride || ''}`;
//   }

//   if (pathName.includes('child-order-summary-new')) {
//     const childPaymentAmount = storeValues?.childPaymentContext?.paymentAmount;
//     const childPaymentType = storeValues?.childPaymentContext?.paymentType;

//     if (childPaymentAmount !== undefined && childPaymentAmount !== null) {
//       payableAmount = String(childPaymentAmount);
//     }
//     if (childPaymentType) {
//       serviceId = childPaymentType;
//     }

//     thankYouPageUrl = `https://${window.location.hostname}${BASE_HREF}/payment-loader?mobileNumber=${msisdn ||
//       ''}&journey=${journey || ''}&orderItemId=${orderItemId ||
//       ''}&landingLayoutOverride=${landingLayoutOverride || ''}`;
//   }

//   const linkRedirectionUrl = `https://${window.location.hostname}${BASE_HREF}/thanks?${linkRedirectionUrlParamsSearchParams.toString()}`;

//   let thankYouPageUrlDeepLink = `myairtel://webview?au=${encodeURIComponent(
//     thankYouPageUrl
//   )}`;
//   if (isNewIOSApp()) {
//     thankYouPageUrlDeepLink = `myairtel://webview?ax=${encodeURIComponent(
//       thankYouPageUrl
//     )}`;
//   }

//   const fullCheckoutPayload = createFullCheckoutPayload(
//     lob,
//     msisdn, // provisionSi
//     cancelUrl,
//     payableAmount, // totalPaymentPrice (string)
//     thankYouPageUrl,
//     serviceId,
//     '',
//     referenceOrderId, // COM order Id
//     msisdn, // rtn
//     linkRedirectionUrl,
//     name, // Added for journeyType = agent and used in SMS when sent to users
//     utm_source,
//     utm_campaign,
//     utm_medium,
//     /* journeyType */ undefined,
//     referenceOrderId,
//     extraData1,
//     address,
//     city,
//     orderItemId,
//     transactionText,
//     primaryHeading,
//     subHeading
//   );

//   const quickCheckoutPayload = createQuickCheckoutPayload(
//     payableAmount,
//     thankYouPageUrlDeepLink,
//     msisdn,
//     referenceOrderId,
//     QcSubtitle,
//     utm_source,
//     utm_campaign,
//     utm_medium,
//     extraData1,
//     address,
//     city,
//     orderItemId
//   );

//    const paymentPayload = async () => {
//     if (isApp) {
//       const { appNumber } = (await getAnalyticsParams()) || {};

//       if (isNewIOSApp()) {
//         if (appNumber > 964) {
//           // Use Quick Checkout on supported iOS app versions
//           makeDigitalStorePayment(quickCheckoutPayload);
//           return '';
//         }
//         return fullCheckoutPayload;
//       } else {
//         if (appNumber > 5714) {
//           // Use Quick Checkout on supported Android app versions
//           makeDigitalStorePayment(quickCheckoutPayload);
//           return '';
//         }
//         return fullCheckoutPayload;
//       }
//     }

//     // Web fallback → full checkout
//     return fullCheckoutPayload;
//   };

//   const payload = await paymentPayload();

//   if (payload !== '') {
//     sessionStorage.setItem('paymentPayload', payload);
//     let url = `https://${window.location.hostname}/pay/?payloadData=${payload}`;

//     sessionStorage.setItem('paymentPayloadUrl', url);

//     return onUserAction?.({
//       actions: [
//         {
//           payload: {
//             args: [],
//             utilName: 'resetOnWebViewCloseCallback',
//           },
//           type: 'callUtilFunction',
//         },
//         {
//           type: 'navigation',
//           payload: { externalUrl: url },
//         },
//       ],
//     });
//   } else {
//     return onUserAction({
//       actions: [],
//     });
//   }
// };

// export const createPostpaidQuickCheckoutPayload = (
//   totalAmount?: string,
//   number?:string,
//   undiscountedAmount?:string
// ) => {
//   const numericPrice = Number(price) || 0;

//   const trackingObj = {
//              "extraData20": "",
//             "eVar26": "modular_broadband_purchase",
//             "eVar20": "6666666666",
//             "city": "GURGAON",
//             "prop13": "Gurgaon",
//             "eVar8": "AAAAAA",
//             "extraData12": "AAAAAAA",
//             "utm_campaign": "",
//             "utm_medium": "",
//             "utm_source": "rail1",
//             "extraData1": "fiber",
//             "adId": ""
//   };


//   const paymentObj={
//     "totalAmount": totalAmount, 
//     "number": number, 
//     "undiscountedAmount": undiscountedAmount,
//     "subtitle": [
//         "POSTPAID",
//         number
//     ], 
//     "paymentLob": "CART_ECOM", 
//     "siNumber": number, 
//     "productCategory": "D2I", 
//     "offersMeta": {
//         "subLob": "POSTPAID",
//         "journeyType": "BookingPayment"
//     }, 
//     "order": {
//         "request": {},
//         "response": {
//             "data": {
//                 "orderId": orderId, 
//                 "orderAmountBreakup": {
//                     "totalAmount": totalAmount, 
//                     "undiscountedAmount": undiscountedAmount,
//                     "subtitle": [
//                         "POSTPAID",
//                         number 
//                     ],
//                     "isGST": false,
//                     "breakupInfo": [
//                         {
//                             "type": "DEFAULT", 
//                             "title": "POSTPAID",
//                             "value": totalAmount
//                         }
//                     ]
//                 },
//                 "paymentDetails": {
//                     "communicationNumber": number, 
//                     "loginId": number, 
//                     "serviceInstance": number,
//                     "orderAmount": totalAmount, 
//                     "undiscountedAmount": undiscountedAmount,
//                     "paymentLob": "CART_ECOM", 
//                     "paymentMeta": {
//                         "lob": "CART_ECOM", 
//                         "postingLobs": [], 
//                         "rechargeOrBill": 1 
//                     }
//                 },
//                 "appliedOffer": []
//             }
//         },
//         "config": {
//             "redirectionURLOnPayment": redirectionURLOnPayment
//         },
//         "bypassOrder": true
//     }, 
//     "flow": {
//         "isAuthFlow": false,
//         "trackingObj": trackingObj
//     } 
// }



//   return JSON.stringify(paymentObj);
// };


export const createWebPostpaidPayload = async ({ args, onUserAction, getState }: any) => {

   const { storeValues } = getState();

   const lob = storeValues?.appData?.lob;
   const msisdn = storeValues?.appData?.msisdn;
   const orderType = storeValues?.appData?.connectionType;
   const siNumber = orderType.toLowerCase() == 'mnp' ? storeValues?.appData?.portingNumber : storeValues?.appData?.newMsisdn
   const rtn = storeValues?.user?.loggedInNumber;
   const payableAmount = lob.toLowerCase() == 'prepaid' ? storeValues?.appData?.planData?.amount : storeValues?.appData?.planData?.activationCharge
   const referenceOrderId = storeValues?.appData?.cartData?.cartId;
   const orderItem = storeValues?.appData?.cartData?.cartItemId ?? '';
   const utm_campaign = storeValues?.additionalData?.queryParams?.utm_campaign || '';
   const utm_medium = storeValues?.additionalData?.queryParams?.utm_medium || '';
   const circleId = storeValues?.appData?.address?.circleId || '';
   const isApp = isMobileApp();

   let params = new URLSearchParams(window.location.search);
   let utm_source = params.get('utm_source') || '';

   let urlParams: { [name: string]: string } = {
      msisdn,
      utm_source,
      payableAmount
   };

   const urlSearchParams = new URLSearchParams(removeBlankAttributes(urlParams));

   const hostname = window.location.hostname;
   const isLocalOrTnd = isLocalOrTndEnv(hostname);
   const redirectHost = isLocalOrTnd ? 'www.airtel.in' : hostname;

   const cancelUrl = `https://www.airtel.in/`;
   //TODO - remove apitype before prod movement
   let thankYouPageUrl = `https://${redirectHost}/kyc/verify?${urlSearchParams?.toString()}`+'apiType=QA';
   let linkRedirectionUrl = '';
   let redirectionUrl = `https://${redirectHost}/pay/summary?omv=v2`;

   // Create deep link URL for mobile apps
   let thankYouPageUrlDeepLink = `myairtel://webview?au=${encodeURIComponent(thankYouPageUrl)}`;
   if (isNewIOSApp()) {
      thankYouPageUrlDeepLink = `myairtel://webview?ax=${encodeURIComponent(thankYouPageUrl)}`;
   }

   const appCheckoutPayload = createAppCheckoutPayload(
      payableAmount,
      thankYouPageUrlDeepLink,
      msisdn,
      rtn,
      siNumber,
      referenceOrderId,
      orderType,
      circleId
   );

   // Create web payment payload data
   const webPaymentPayload = createPaymentPayLoadForWeb(
      lob,
      msisdn, //provisionSi
      siNumber,
      cancelUrl,
      payableAmount, //totalPaymentPrice
      thankYouPageUrl,
      referenceOrderId, // COM order Id
      msisdn, // rtn
      utm_source,
      utm_campaign,
      utm_medium,
      linkRedirectionUrl,
      orderItem,
      orderType,
      redirectionUrl,
      circleId
   );

   const paymentPayload = async () => {
      if (isApp) {
         const { appNumber } = (await getAnalyticsParams()) || {};

         if (isNewIOSApp()) {
            //TODO - appNumber will changes post payment changes are released in bridge
            if (appNumber > 964) {
               makeDigitalStorePayment(appCheckoutPayload);
               return ""
            } else {
               return webPaymentPayload
            }
         } else {
            if (appNumber > 5714) {
               makeDigitalStorePayment(appCheckoutPayload);
               return ""
            } else {
               return webPaymentPayload
            }
         }
      } else {
         return webPaymentPayload
      }
   };

   const payload = await paymentPayload();


   // Web payment flow - executes for web and in app where appNumber is below configured values
   // payload === "" means makeDigitalStorePayment was called (native payment) — nothing more to do
   if (payload === "") {
      return;
   }

     let url = `https://www.airtel.in/pay/?payloadData=${payload}`


   if (!hostname.includes("airtel.in")) {
      url += `&apiEnv=KONG178`
        redirectionUrl += `&apiEnv=KONG178`  
   }

   console.log("paymentPayload",paymentPayload)
   if (payload != null) {
    
      // sessionStorage.setItem('paymentPayloadUrl', url);

      return onUserAction({
         actions: [
            {
               type: 'navigation',
               payload: {
                  externalUrl: url,
                  shouldAddSearchParams: false,
                  shouldOpenWindow: isEmbeddedInIframe(),
               },
            },
         ],
      });
   }
};


